import { render, staticRenderFns } from "./Informaition.vue?vue&type=template&id=b594fbfc&scoped=true"
import script from "./Informaition.vue?vue&type=script&lang=js"
export * from "./Informaition.vue?vue&type=script&lang=js"
import style0 from "./Informaition.vue?vue&type=style&index=0&id=b594fbfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b594fbfc",
  null
  
)

export default component.exports